import { render, staticRenderFns } from "./StoreMinDeliveryMinutesModal.vue?vue&type=template&id=19988509&"
import script from "./StoreMinDeliveryMinutesModal.vue?vue&type=script&lang=js&"
export * from "./StoreMinDeliveryMinutesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19988509')) {
      api.createRecord('19988509', component.options)
    } else {
      api.reload('19988509', component.options)
    }
    module.hot.accept("./StoreMinDeliveryMinutesModal.vue?vue&type=template&id=19988509&", function () {
      api.rerender('19988509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/components/StoreMinDeliveryMinutesModal.vue"
export default component.exports